import styled from 'styled-components';
import { Input } from 'ui-components/src/components/atoms/Input';

export const StyledInput = styled(Input)`
  margin-top: 12px;
`;
